import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUa = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 512,
	height: 512,
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "a",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#fff"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#ffd700",
			d: "m0 256 258-39.4L512 256v256H0z"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#0157b7",
			d: "M0 0h512v256H0z"
		})]
	})]
});
export default SvgUa;
